import React from "react";

import Box from "../Box";
import Text from "../Text";
import { MarginProps } from "styled-system";
import { useTranslation } from "react-i18next";

type ErrorOrLoadingScreenProps = {
  isUnavailable: boolean;
  size: "small" | "big";
  messageError?: string;
  height?: Array<number>;
  otherMsg?: string;
} & MarginProps;

const ErrorOrLoadingScreen = ({
  isUnavailable,
  size,
  messageError,
  height,
  otherMsg,
  ...rest
}: ErrorOrLoadingScreenProps) => {
  const { t } = useTranslation();
  return (
    <Box
      bg="brand5"
      width="100%"
      minHeight={size === "small" ? "68px" : "192px"}
      height={height ? height : "100%"}
      borderRadius="12px"
      display="flex"
      flexDirection={"column"}
      alignItems="center"
      justifyContent="center"
      overflow={"hidden"}
      {...rest}
    >
      {isUnavailable ? (
        <Text variant={["title2Bold", "title1Bold"]} color="blueDarkVeil">
          {messageError ? messageError : t('common.no_data')}
        </Text>
      ) : (
        <Text variant={["title2Bold", "title1Bold"]} color="blueDarkVeil">
          {t('common.chargement')}
        </Text>
      )}

      {otherMsg && (
        // <Box display={"flex"}>
        <Text
          variant={["title3Bold", "title2Bold"]}
          color="blueDarkVeil"
          mt={1}
        >
          {otherMsg ? otherMsg : ""}
        </Text>
        // </Box>
      )}
    </Box>
  );
};

export default ErrorOrLoadingScreen;
